"use client";

// KininaruButton — "👀 気になる" action with auth gating.
//
// Usage:
//   <KininaruButton profileId={it.id} />
//
// On mount: fetches GET /api/kininaru?profileId=... to restore persisted state.
// Signed in  → POST /api/kininaru, then show "👀 気になっている"
// Signed out → opens Clerk sign-in modal; resumes click after auth

import { useEffect, useState } from "react";
import { useGatedAction } from "@/hooks/useGatedAction";

type Props = { profileId: string };

export default function KininaruButton({ profileId }: Props) {
  const [active, setActive] = useState(false);
  const [checked, setChecked] = useState(false); // true once initial fetch resolves

  useEffect(() => {
    fetch(`/api/kininaru?profileId=${encodeURIComponent(profileId)}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.active) setActive(true);
      })
      .catch(() => {})
      .finally(() => setChecked(true));
  }, [profileId]);

  const trigger = useGatedAction(() => {
    fetch("/api/kininaru", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ profileId }),
    })
      .then((res) => { if (res.ok) setActive(true); })
      .catch(() => {});
  });

  if (!checked) {
    return (
      <button
        disabled
        style={{
          fontSize: 13,
          padding: "4px 12px",
          border: "1px solid #e0e0e0",
          borderRadius: 6,
          background: "#fafafa",
          color: "#bbb",
          cursor: "default",
        }}
      >
        👀
      </button>
    );
  }

  return (
    <button
      onClick={trigger}
      disabled={active}
      style={{
        fontSize: 13,
        padding: "4px 12px",
        border: "1px solid #ccc",
        borderRadius: 6,
        background: active ? "#f5f5f5" : "#fff",
        color: "#333",
        cursor: active ? "default" : "pointer",
      }}
    >
      {active ? "👀 済" : "👀 気になる"}
    </button>
  );
}
